import { AutenticacionService } from '../autenticacion.service';
import { Http, URLSearchParams, ResponseContentType } from '@angular/http';
import { ConstantsService } from '../constants.service';
import { Injectable } from '@angular/core';

@Injectable()
export class ReportesClientesService {

  private service_url : string = '';
  constructor(
      private constantsService: ConstantsService, 
      private http: Http, 
      private authService: AutenticacionService
  ) {
    this.service_url = this.constantsService.apiURL + '/reportes/clientes';
  }

  public getReporteGeneral(filters : any) {
    let myParams = new URLSearchParams();

    if(filters.cliente){
      myParams.append('cliente', filters.cliente);
    }

    if(filters.tipoCredito){
        myParams.append('tipo_credito', filters.tipoCredito);
    }

     if(filters.sucursal){
      myParams.append('sucursal', filters.sucursal);
    }
    
    let myoptions = this.authService.getAuthHeaders();
    myoptions.params = myParams;
    
    let serviceUrl = this.service_url + '/general';
    
    return this.http.get(serviceUrl , myoptions);
  }

  public exportReporteGeneralToExcel(filters : any) {
    let myParams = new URLSearchParams();

    if(filters.cliente){
        myParams.append('cliente', filters.cliente);
    }

    if(filters.tipoCredito){
        myParams.append('tipo_credito', filters.tipoCredito);
    }

     if(filters.sucursal){
      myParams.append('sucursal', filters.sucursal);
    }
    
    const options = this.authService.getAuthHeaders();
    options.params = myParams;

    let serviceUrl = this.service_url + '/general/export';
    options.responseType = ResponseContentType.Blob;
    return this.http.get(serviceUrl, options);
  }

}


// WEBPACK FOOTER //
// ./src/app/services/reportes/reportes-clientes.service.ts